import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

type Variant = "feature" | "dark" | "code" | "coral" | "plain";

const variantClasses: Record<Variant, string> = {
  feature: "bg-surface-card text-ink",
  dark: "bg-surface-dark text-on-dark",
  code: "bg-surface-dark text-on-dark font-code",
  coral: "bg-primary text-on-primary",
  plain: "bg-canvas text-ink border border-hairline",
};

export function Card({
  variant = "plain",
  className,
  children,
  ...props
}: { variant?: Variant; className?: string; children: ReactNode } & HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("rounded-lg p-8", variantClasses[variant], className)} {...props}>
      {children}
    </div>
  );
}
